import React from 'react'
import { useEffect } from 'react'
import classes from './Contract.module.css'
import SupportingDocuments from './SupportingDocuments/SupportingDocuments';
import CompanyDetails from './CompanyDetails'
import { closeSlidingPopUp, Activity, ActivityString, currentRequestTimeStamp } from './../../Constants'
import { useAppContext } from "../../Context/AppContext";
import mixpanel from 'mixpanel-browser';
import { Urls } from '../../Urls';
import AdditionalDocuments from './AdditionalDocuments/AdditionalDocuments'

const Contract = props => {
    const {transporterInfo} = useAppContext();
    useEffect(() => {
        document.title = 'LoRRI Profile - Contract Closure'
        Activity([{ "screen": ActivityString.ContractInfo, "module": "Contract Closure Info", "user_activity": ActivityString.ContractClosurePageView, "timestamp": currentRequestTimeStamp() }])
        mixpanel.track('User has viewed contract closure information page', {
            // distinct_id: 'unique client id',
            ApplicationName: `${Urls.appnamemixpanel}`,
            ScreenName: 'Transporter-Profile',
            ModuleName: 'contract-closure',
            ActivityLog: 'userViewedContractClosureInformation',
            Data: 'None',
            Definition: 'User has viewed contract closure information page',
            TransporterName: transporterInfo.transporter_name,
            TransporterId: transporterInfo.transporter_id,
            ActivityType: 'page_view'
          });
        closeSlidingPopUp()
    }, [])

    return (
        <div className={classes.container}>
            <h3 className={`${classes['s-h3']}`}>Contract Closure Information</h3>
            <CompanyDetails/>
            <SupportingDocuments/>
            <AdditionalDocuments/>
        </div>
    )
}


export default Contract
